module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "tit1"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Hotspur")])]), _vm._v(" "), _c('p', {
    staticClass: "stit1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sir Henry Percy and the")])]), _vm._v(" "), _c('p', {
    staticClass: "stit2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Myth of Chivalry")])]), _vm._v(" "), _c('p', {
    staticClass: "stit3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("L’audace, l’audace, toujors l’audace")]), _vm._v(" (Danton)")]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("John Sadler")])]), _vm._v(" "), _c('p', {
    staticClass: "author2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Foreword by Ralph Percy,")])])]), _vm._v(" "), _c('p', {
    staticClass: "author3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("12th Duke of Northumberland")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/pub.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c0d47ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Title.vue
// module id = 60
// module chunks = 0